import { STC_VARIANT, readCount } from "../_variants/index.js";

import { pad } from "../../../utils.js";

/**
 * Build the seed Documents for a newly-created Design Change.
 *
 * Produces an in-memory list of document records — the caller is responsible
 * for pushing them to the appropriate Firebase collection (the variant's
 * `Database/<prefix>Documents` path) and updating refs/counts.
 *
 * @param {object}  args
 * @param {object}  args.store
 * @param {object}  args.db
 * @param {object}  args.parent      - the Design Change record (incl. ID, Number, Title)
 * @param {string}  args.parentType  - e.g. "DesignChanges" or "MilitaryDesignChanges"
 * @param {import("../_variants/index.js").Variant} [args.variant=STC_VARIANT]
 *        Variant of the parent — drives the document number prefix and which
 *        counter on the DocumentType record is consumed.
 */
export const createBasicDocuments = async ({ store, db, parent, parentType, variant = STC_VARIANT }) => {
    const documentTypes = Object.values(await db.store("Database/DocumentTypes", store))    ;

    const newDocuments = [];

    for (const type of documentTypes) {
        
        if (!type.Standard || !type.Standard?.[parentType]) {
            continue;
        }

        const count = readCount(type, variant, "Count");

        newDocuments.push({
            "Number": `${variant.docPrefix}${type.NameShort}-${pad(count)}`,
            "Title": parent.Title,
            "Date": {
                "Created": new Date().toISOString(),
                "Cancelled": "N/A",
                "Signedoff": "N/A"
            },
            "Cancelled": false,
            "Signedoff": false,
            "Parent": parent.Number,
            "ParentID": parent.ID,
            "ParentType": parentType,
            [parentType]: {
                [parent.ID]: true
            },
            "Type": type.NameShort,
            "TypeID": type.ID,
            // Snapshot of the counter consumed for this document — the caller
            // uses this to compute the next value when bumping the type's
            // count. (Replaces the old `type.Count` snapshot.)
            "Count": count,
            "MPDS": false,
            "Revision": 1,
            "RevisionID": `--R1`,
            "Revisions": {
                "--R1": {
                    "Revision": 1,
                    "Reason": "Document Created",
                    "ID": "--R1",
                    "Date": new Date().toISOString(),
                    "Quality": {
                        "Approver": {
                            "By": "N/A",
                            "Completed": false,
                            "Date": "N/A"
                        },
                        "Checker": {
                            "By": "N/A",
                            "Completed": false,
                            "Date": "N/A"
                        },
                        "Compiler": {
                            "By": "N/A",
                            "Completed": false,
                            "Date": "N/A"
                        }
                    }
                }
            },
            "Links": {
                [parent.ID]: "--R1"
            }
        });
    }

    return newDocuments;
};
